"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComparisonOperators = {
    MATCH_GREATER_OR_EQUAL: '>=',
    MATCH_LESS_OR_EQUAL: '<=',
    MATCH_GREATER: '>',
    MATCH_LESS: '<',
    MATCH_GTE: 'more_or_equals',
    MATCH_LTE: 'less_or_equals',
    MATCH_GT: 'more_than',
    MATCH_LT: 'less_than',
    MATCH_CONTAINS: 'contains',
    MATCH_DOES_NOT_CONTAIN: 'not_contains',
    MATCH_EQUALS: 'equals',
    MATCH_NOT_EQUALS: 'not_equals',
    MATCH_STARTS_WITH: 'starts_with',
    MATCH_DOES_NOT_START_WITH: 'not_starts_with',
    MATCH_ENDS_WITH: 'ends_with',
    MATCH_DOES_NOT_END_WITH: 'not_ends_with',
    MATCH_REGEX: 'matches_regex',
    MATCH_IN: 'matchIn',
    DOES_NOT_MATCH_IN: 'not_matchIn',
    DOES_NOT_MATCH_REGEX: 'not_matches_regex',
    IS_EMPTY: 'is_empty',
    NOT_IS_EMPTY: 'not_is_empty',
};
//# sourceMappingURL=comparison-operator.value.js.map